"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Spinner;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _spinner = _interopRequireDefault(require("../../images/spinner.gif"));
const Image = _styled.default.img({
  height: '90px',
  width: '90px'
});
function Spinner(_ref) {
  let {
    ...params
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(Image, Object.assign({
    alt: "OneASICS loading logo",
    src: _spinner.default
  }, params));
}